export default class CreateWebhookRequest {
    name: string = '';
    enabled: boolean = true;
    eventType: string = "TEST";
    url: string = '';
}